import { render, staticRenderFns } from "./InstallmentTrxView.vue?vue&type=template&id=3c289dbd"
import script from "./InstallmentTrxView.vue?vue&type=script&lang=js"
export * from "./InstallmentTrxView.vue?vue&type=script&lang=js"
import style0 from "./InstallmentTrxView.vue?vue&type=style&index=0&id=3c289dbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports